import store from '@/store';
const Medium = () => import(/* webpackChunkName: "notice" */'@/components/pages/notice/medium/Medium');
const Template = () => import(/* webpackChunkName: "notice" */'@/components/pages/notice/template/Template');
const OperateTemplatePage = () => import(/* webpackChunkName: "notice" */'@/components/pages/notice/template/OperateTemplatePage');
const NoticeRecord = () => import(/* webpackChunkName: "notice" */'@/components/pages/notice/record/Record');
const NoticeConfig = () => import(/* webpackChunkName: "notice" */'@/components/pages/notice/config/Config');
const TopMenu = () => import(/* webpackChunkName: "base" */'@/components/common/TopMenu');
const routerMapping = {
  'SYS_NOTICE_MEDIUM_QUERY': '/system/notice/system-medium',
  'SYS_NOTICE_TEMPLATE_QUERY': '/system/notice/template',
  'SYS_NOTICE_RECORD_QUERY': '/system/notice/record',
  'SYS_NOTICE_CONFIG_QUERY': '/system/notice/config'
}
export default [
  {
    path: 'notice',
    name: 'notice',
    redirect: () => {
      let index = store.state.tab.workPages.findIndex(p => p.secondParent === '/system/notice');
      if (index > -1) {
        return store.state.tab.workPages[index].routePath;
      } else {
        const roleIds = store.state.base.roleIds;
        let router = '/system/notice/system-medium';
        for (var item in routerMapping) {
          if (roleIds.includes(item)) {
            router = routerMapping[item];
            break;
          }
        }
        return router;
      }
    },
    component: TopMenu,
    meta: {
      title: '通知管理',
      roles: [
        'SYS_NOTICE_MEDIUM_QUERY',
        'SYS_NOTICE_TEMPLATE_QUERY',
        'SYS_NOTICE_RECORD_QUERY',
        'SYS_NOTICE_CONFIG_QUERY'
      ],
      activeMenu: '/system/notice',
      componentName: 'TopMenu'
    },
    children: [
      {
        path: 'system-medium',
        name: 'medium',
        meta: {
          title: '通知参数',
          roles: ['SYS_NOTICE_MEDIUM_QUERY'],
          componentName: 'NoticeMedium',
          breadcrumb: [
            {
              name: '通知参数',
              path: '/system/notice/system-medium'
            }
          ],
        },
        component: Medium
      },
      {
        path: 'template',
        name: 'noticeTemplate',
        meta: {
          title: '通知模板',
          roles: ['SYS_NOTICE_TEMPLATE_QUERY'],
          componentName: 'NoticeTemplate',
          breadcrumb: [
            {
              name: '通知模板',
              path: '/system/notice/template'
            }
          ],
        },
        component: Template
      },
      {
        path: 'edit-template/:id',
        props: true,
        name: 'editNoticeTemplate',
        meta: {
          title: '编辑通知模板',
          hidden: true,
          activeMenu: '/system/notice/template',
          roles: ['SYS_NOTICE_TEMPLATE_UPDATE'],
          componentName: 'OperateNoticeTemplatePage',
          breadcrumb: [
            {
              name: '通知模板',
              path: '/system/notice/template'
            },
            {
              name: '编辑通知模板',
              path: '/system/notice/edit-template/:id'
            }
          ]
        },
        component: OperateTemplatePage
      },
      {
        path: 'create-template',
        name: 'createNoticeTemplate',
        meta: {
          title: '新建通知模板',
          hidden: true,
          activeMenu: '/system/notice/template',
          roles: ['SYS_NOTICE_TEMPLATE_ADD'],
          componentName: 'OperateNoticeTemplatePage',
          breadcrumb: [
            {
              name: '通知模板',
              path: '/system/notice/template'
            },
            {
              name: '新建通知模板',
              path: '/system/notice/create-template'
            }
          ]
        },
        component: OperateTemplatePage
      },
      {
        path: 'record',
        name: 'noticeRecord',
        meta: {
          title: '通知记录',
          roles: ['SYS_NOTICE_RECORD_QUERY'],
          componentName: 'NoticeRecord',
          breadcrumb: [
            {
              name: '通知记录',
              path: '/system/notice/record'
            }
          ],
        },
        component: NoticeRecord
      },
      {
        path: 'config',
        name: 'noticeConfig',
        meta: {
          title: '通知配置',
          roles: ['SYS_NOTICE_CONFIG_QUERY'],
          componentName: 'NoticeConfig',
          breadcrumb: [
            {
              name: '通知配置',
              path: '/system/notice/noticeConfig'
            }
          ],
        },
        component: NoticeConfig
      },
    ]
  },
];



// WEBPACK FOOTER //
// ./src/router/notice.js